function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { useCss } from './use-css.js';
import { useMantineTheme, useMantineProviderStyles, useMantineEmotionCache } from '../theme/MantineProvider.js';
import { mergeClassNames } from './utils/merge-class-names/merge-class-names.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
function assignAccStyles(acc, styles) {
    if (styles) {
        Object.keys(styles).forEach(function(key) {
            if (!acc[key]) {
                acc[key] = __spreadValues({}, styles[key]);
            } else {
                acc[key] = __spreadValues(__spreadValues({}, acc[key]), styles[key]);
            }
        });
    }
    return acc;
}
function getStyles(styles, theme, params, contextParams) {
    var extractStyles = function(stylesPartial) {
        return typeof stylesPartial === "function" ? stylesPartial(theme, params || {}, contextParams) : stylesPartial || {};
    };
    if (Array.isArray(styles)) {
        return styles.map(function(item) {
            return extractStyles(item.styles);
        }).reduce(function(acc, item) {
            return assignAccStyles(acc, item);
        }, {});
    }
    return extractStyles(styles);
}
function getContextVariation(param) {
    var ctx = param.ctx, theme = param.theme, params = param.params, variant = param.variant, size = param.size;
    return ctx.reduce(function(acc, item) {
        if (item.variants && variant in item.variants) {
            assignAccStyles(acc, item.variants[variant](theme, params, {
                variant: variant,
                size: size
            }));
        }
        if (item.sizes && size in item.sizes) {
            assignAccStyles(acc, item.sizes[size](theme, params, {
                variant: variant,
                size: size
            }));
        }
        return acc;
    }, {});
}
function createStyles(input) {
    var getCssObject = typeof input === "function" ? input : function() {
        return input;
    };
    function useStyles(params, options) {
        var theme = useMantineTheme();
        var context = useMantineProviderStyles(options == null ? void 0 : options.name);
        var cache = useMantineEmotionCache();
        var contextParams = {
            variant: options == null ? void 0 : options.variant,
            size: options == null ? void 0 : options.size
        };
        var _useCss = useCss(), css = _useCss.css, cx = _useCss.cx;
        var cssObject = getCssObject(theme, params, contextParams);
        var componentStyles = getStyles(options == null ? void 0 : options.styles, theme, params, contextParams);
        var providerStyles = getStyles(context, theme, params, contextParams);
        var contextVariations = getContextVariation({
            ctx: context,
            theme: theme,
            params: params,
            variant: options == null ? void 0 : options.variant,
            size: options == null ? void 0 : options.size
        });
        var classes = Object.fromEntries(Object.keys(cssObject).map(function(key) {
            var mergedStyles = cx(_define_property({}, css(cssObject[key]), !(options == null ? void 0 : options.unstyled)), css(contextVariations[key]), css(providerStyles[key]), css(componentStyles[key]));
            return [
                key,
                mergedStyles
            ];
        }));
        return {
            classes: mergeClassNames({
                cx: cx,
                classes: classes,
                context: context,
                classNames: options == null ? void 0 : options.classNames,
                name: options == null ? void 0 : options.name,
                cache: cache
            }),
            cx: cx,
            theme: theme
        };
    }
    return useStyles;
}
export { createStyles }; //# sourceMappingURL=create-styles.js.map
